// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GOOGLE_BOOKS_API_URL = 'https://www.googleapis.com/books/v1/volumes'; 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GOOGLE_BOOKS_API_KEY = process.env.REACT_APP_GOOGLE_BOOKS_API_KEY;

// Update this URL after deploying the new backend
const BASE_URL = "http://localhost:5001/"; // For local development
// const BASE_URL = "https://your-new-backend.elasticbeanstalk.com/"; // For production

// Email Verification Endpoints
export const sendVerificationCode = async (userData: {
  email: string;
  first_name: string;
  last_name: string;
  school: string;
}) => {
  try {
    const response = await fetch(`${BASE_URL}send-verification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
      body: JSON.stringify(userData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to send verification code');
    }
    
    return data;
  } catch (error) {
    console.error('Error sending verification code:', error);
    throw error;
  }
};

export const verifyCode = async (verificationData: {
  email: string;
  code: string;
  first_name: string;
  last_name: string;
  school: string;
}) => {
  try {
    const response = await fetch(`${BASE_URL}verify-code`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
      body: JSON.stringify(verificationData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to verify code');
    }
    
    return data;
  } catch (error) {
    console.error('Error verifying code:', error);
    throw error;
  }
};

// Session Management Endpoints
export const login = async (loginData: {
  email: string;
  code: string;
}) => {
  try {
    const response = await fetch(`${BASE_URL}login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
      body: JSON.stringify(loginData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Login failed');
    }
    
    return data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const response = await fetch(`${BASE_URL}logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Logout failed');
    }
    
    return data;
  } catch (error) {
    console.error('Error logging out:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await fetch(`${BASE_URL}me`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to get current user');
    }
    
    return data;
  } catch (error) {
    console.error('Error getting current user:', error);
    throw error;
  }
};

// Listing Endpoints
export const getUserListingByID = async (id: number) => {
  try {
    const response = await fetch(`${BASE_URL}listing/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to get listing');
    }
    
    return data;
  } catch (error) {
    console.error('Error getting listing:', error);
    throw error;
  }
};

export const getListingByISBN = async (isbn: number) => {
  try {
    const response = await fetch(`${BASE_URL}listings/search?q=${isbn}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to search listings');
    }
    
    return data;
  } catch (error) {
    console.error('Error searching listings:', error);
    throw error;
  }
};

export const searchListings = async (query: string) => {
  try {
    const response = await fetch(`${BASE_URL}listings/search?q=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to search listings');
    }
    
    return data;
  } catch (error) {
    console.error('Error searching listings:', error);
    throw error;
  }
};

export const createListing = async (listingData: {
  name: string;
  author: string;
  isbn: string;
  book_type: 'Hardcover' | 'Paperback';
  condition: 'worn' | 'like new gently used';
  school: string;
  price: number;
}) => {
  try {
    const response = await fetch(`${BASE_URL}create-listing`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
      body: JSON.stringify(listingData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to create listing');
    }
    
    return data;
  } catch (error) {
    console.error('Error creating listing:', error);
    throw error;
  }
};

export const queryBooksAPI = async (query: string) => {
  try {
    const apiKey = GOOGLE_BOOKS_API_KEY ? `&key=${GOOGLE_BOOKS_API_KEY}` : '';
    const response = await fetch(`${GOOGLE_BOOKS_API_URL}?q=${encodeURIComponent(query)}&maxResults=5${apiKey}`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch from Google Books API');
    }
    
    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error('Error querying Google Books API:', error);
    throw error;
  }
};